
import base from "@packages/api/core/baseCore";
import Vue from "vue";

export default Object.assign(
    {
        apiUrl: "/voucher/clients",

        async list({ segmentId, search, page }) {
            const url = this.url(`/list/${segmentId}`);

            return Vue.http.get(url, {
                params: {
                    page,
                    filter: search
                }
            });
        },

        async generate({ segmentId, quantity, useLimit, comment, expirationDate }) {
            const url = this.url(`/generate/${segmentId}`);

            return Vue.http.post(url, {
                quantity, 
                useLimit, 
                comment,
                expirationDate
            });
        },

        async create({ 
            segmentId,  
            login,
            password,
            voucherCode,
            useCounter,
            comment,
            expirationDate 
        }) {
            const url = this.url(`/segment/${segmentId}`);

            return Vue.http.post(url, {
                login,
                password,
                voucherCode,
                useCounter,
                comment,
                expirationDate 
            });
        },

        async upload({ 
            segmentId,  
            formData
        }) {
            const url = this.url(`/upload/${segmentId}`);

            return Vue.http.post(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
        },

        async delete({ clientId }) {
            const url = this.url(`/segment/${clientId}`);

            return Vue.http.delete(url);
        },
    },
    base
);
